import { Typography } from "@packages/ds";
import styled from "styled-components";

import CPageDescription from "Components/PageDescription";
import { Content as DsContent } from "ds/Dialog";

export const NoteWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 32px;
`;

export const Content = styled(DsContent)`
  display: block;
  width: 591px;
`;

export const EnvVariableTitle = styled(Typography.Title)`
  margin-bottom: 11px;
`;

export const PageDescription = styled(CPageDescription)`
  padding-top: 0;
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;
